import React from "react";
import { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { useForm, Controller } from 'react-hook-form';
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import CalendarElement from "../../../../Components/UiComponents/CalendarElement";
import { Accordion, AccordionTab } from 'primereact/accordion';
import DataTable from "../../../../Components/UiComponents/DataTable";
import InputTextElement from "../../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { Dialog } from "primereact/dialog";
import { getBranchUser, getUsersList } from "../../../../Services/userService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { addBidTeam } from "../../../../Services/opportunityService";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Moment from "moment";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";


export default function Team(props) {
    const [customerId, setCustomerId] = useState(null);
    const [customer, setCustomer] = useState({});
    const [newModule, setNewModule] = useState({});
    const [branchIdFromLS, setBranchIdFromLS] = useState();
    const [opportunityData, setOpportunityData] = useState({});
    const [newOpportunityData, setNewOpportunityData] = useState({});
    const [isModelOpen, setModelOpen] = useState(false);
    const [branchDetail, setBranchDetail] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [roles, setRoles] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const { register, handleSubmit, formState: reset, setValue, getValues, trigger, watch, control } = useForm();
    const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()
    const [showVideo, setShowVideo] = useState(false);

    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
        const tmpPrivilege = JSON.parse(userprivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var teamEditPrivilege = tmpPrivilege[0].bid_team_edit;
        }
    }

    const teamLeader = ["Project Leader", "Bid Leader"];

    const toastRef = useRef();

    useEffect(() => {
        const enduserStr = localStorage.getItem("enduser");
        if (enduserStr) {
            const enduser = JSON.parse(enduserStr);
            setCustomer(enduser);
            const customer = enduser.customer;
            setCustomerId(customer);
            const branch = enduser.branch;
            setBranchIdFromLS(branch);
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (props.TeamData.pipelineBidSections) {
            let obj1 = _.find(props.TeamData.pipelineBidSections, { section_name: "Internal BidTeam" })?.display_name;
            let obj2 = _.find(props.TeamData.pipelineBidSections, { section_name: "External Costs" })?.display_name;

            var combined = {}
            combined = { obj1, obj2 };
            setNewModule(combined);
        }
    }, [props?.TeamData?.pipelineBidSections])

    useEffect(() => {
        if (props.opportunityData) {
            setOpportunityData(props.opportunityData)
        }
    }, [props.customerId, props.opportunityData]);

    useEffect(() => {
        setNewOpportunityData(props.opportunityData)
    }, [props?.TeamData?.tableFieldsBidTeam])


    const handleUserChange = (selectedOption) => {
        setSelectedUser(selectedOption);
        const selectedUserDetail = props.relationshipOwner.find(user => user._id === selectedOption.value._id);
        if (selectedUserDetail) {
            setRoles(selectedUserDetail.role_name);
            setSelectedId(selectedUserDetail._id);
        } else {
            setRoles("");
        }
    };

    const addBidLeaderToTeam = async () => {
        if(opportunityData?.bid_Leader_id){
            if(!opportunityData.ie_bid_team.internal_bid_team?.some(user => user.user_id === opportunityData.bid_Leader_id)){
                const response = await getUsersList(props.customerId, props.branch);
                const bid_leader = _.find(response.data, { _id: opportunityData.bid_Leader_id});
                const newBidLeaders = {
                    role: bid_leader.role_name,
                    bid_team_role: "Project Leader",
                    team_member: opportunityData.bid_Leader,
                    user_id: bid_leader._id,
                    hourly_rate: bid_leader.hourlyrate,
                };
                setOpportunityData((prevOpportunityDetails) => ({
                    ...prevOpportunityDetails,
                    ['ie_bid_team']: {
                        ...prevOpportunityDetails['ie_bid_team'],
                        ['internal_bid_team']: [
                            ...prevOpportunityDetails['ie_bid_team']['internal_bid_team'],
                            newBidLeaders
                        ]
                    }
                }));
            }           
        }
    } 

    useEffect(() => {
        addBidLeaderToTeam()
    }, [opportunityData]);

    // const getBranchUsers = async () => {
    //     // Ensure customerId is not null
    //     if (branchIdFromLS !== null) {
    //         try {
    //             // Fetch customer data from the server
    //             const branchUserDataResponse = await getBranchUser(props?.customerId, props?.branch?.branch_id);
    //             setBranchDetail(branchUserDataResponse.data)
    //             // setBranchDetails(customerDataResponse?.data?.branch)
    //         } catch (error) {
    //             // Log and notify if there's an error fetching customer data
    //             console.error("Error fetching branch fields:", error);
    //         }
    //     }
    // };

    const getBranchUsers = async () => {
        if (branchIdFromLS !== null) {
            try {
                setLoading(true);

                // Fetch branch user data from the server
                const branchUserDataResponse = await getBranchUser(props?.customerId, props?.branch?.branch_id);

                if (branchUserDataResponse && branchUserDataResponse.data) {
                    setBranchDetail(branchUserDataResponse.data);
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: "Failed to retrieve branch user data.",
                    });
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: "error",
                    message: "Error fetching branch user data. Please try again or contact Admin.",
                });
            } finally {
                setLoading(false);
            }
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "No branch ID provided. Please select a valid branch.",
            });
        }
    };


    // const onSubmit = async (data) => {
    //     if (selectedId !== null) {
    //         try {
    //             const bidTeamDataResponse = await addBidTeam(props?.opportunityData?._id, props?.customerId, selectedId);

    //             if (bidTeamDataResponse?.status === 200) {
    //                 toastRef.current.showToast({
    //                     type: "success",
    //                     message: bidTeamDataResponse?.data?.message,
    //                 });
    //                 props.getData('success')
    //                 closePopup();
    //             }
    //             else {
    //                 toastRef.current.showToast({
    //                     type: "error",
    //                     message: "Error while adding",
    //                 });
    //             }
    //         } catch (error) {
    //             console.error("Error calling API", error);
    //         }
    //     }
    // };

    const onSubmit = async (data) => {
        if (selectedId !== null) {
            try {
                setLoading(true);

                // Call the API to add the bid team
                const bidTeamDataResponse = await addBidTeam(props?.opportunityData?._id, props?.customerId, selectedId);

                // Check if the response status is 200 (success)
                if (bidTeamDataResponse && bidTeamDataResponse.status === 200) {
                    toastRef.current.showToast({
                        type: "success",
                        message: bidTeamDataResponse?.data?.message,
                    });
                    // Trigger a data refresh and close the popup
                    props.getData('success');
                    closePopup();
                } else {
                    // Handle cases where status is not 200
                    toastRef.current.showToast({
                        type: "error",
                        message: "Error while adding",
                    });
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: "error",
                    message: "Failed to add bid team. Please try again or contact Admin."
                });
            } finally {
                setLoading(false);
            }
        } else {
            // Handle case where no selectedId is provided
            toastRef.current.showToast({
                type: "error",
                message: "Please select a valid team member before submitting."
            });
        }
    };


    const parseDateString = (dateString) => {
        if (dateString) {
            const [day, month, year] = dateString.split('-')?.map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
        }
    };

    const onTextChangeEstHours = (index, field) => (e) => {
        const newEstHours = [...opportunityData?.ie_bid_team.internal_bid_team];
        if (field === "total_est_hours") {
            newEstHours[index][field] = e.target.value;
        } else {
            newEstHours[index][field] = e.target.value;
        }
        setOpportunityData({
            ...opportunityData,
            ie_bid_team: {
                ...opportunityData.ie_bid_team,
                internal_bid_team: newEstHours
            }
        });
    };

    const onTextChangeExternal = (index, field) => (e) => {
        const updatedTextChange = [...opportunityData?.ie_bid_team.external_bid_team];
        if (updatedTextChange) {
            updatedTextChange[index][field] = e.target.value;
        }
        setOpportunityData({
            ...opportunityData,
            ie_bid_team: {
                ...opportunityData.ie_bid_team,
                external_bid_team: updatedTextChange
            }
        });
    };

    useEffect(() => {
        getBranchUsers();
    }, [branchIdFromLS, props.customerId]); useEffect(() => {
        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            ie_bid_team: {
                ...prevData.ie_bid_team,
                external_bid_team: opportunityData?.ie_bid_team?.external_bid_team,
                internal_bid_team: opportunityData?.ie_bid_team?.internal_bid_team,
            },
        }));
    }, [opportunityData.ie_bid_team]);

    const handleCalenderInputChangeExt = (field, value, index) => {
        const updatedArrayData = { ...opportunityData };
        updatedArrayData.ie_bid_team.external_bid_team[index][field] = Moment(value).format("DD-MM-YYYY");
        setOpportunityData(updatedArrayData);
    }

    const handleCalenderInputChange = (field, value, index) => {
        const updatedArrayData = { ...opportunityData };
        updatedArrayData.ie_bid_team.internal_bid_team[index][field] = Moment(value).format("DD-MM-YYYY");
        setOpportunityData(updatedArrayData);
    }

    const handleCompleted = (e, position, field) => {
        const isChecked = e.target.checked;
        const updatedEntities = opportunityData?.ie_bid_team.internal_bid_team.map((subscription, index) => {
            const updatedSubscription = { ...subscription };
            updatedSubscription[field] = (parseInt(position) === parseInt(index)) ? isChecked : false;
            return updatedSubscription;
        });
        setOpportunityData({
            ...opportunityData,
            ie_bid_team: {
                ...opportunityData.ie_bid_team,
                internal_bid_team: updatedEntities
            }
        });
    };

    const handleCompletedExternal = (e, position, field) => {
        const isChecked = e.target.checked;
        const updatedEntities = opportunityData?.ie_bid_team.external_bid_team.map((subscription, index) => {
            const updatedSubscription = { ...subscription };
            updatedSubscription[field] = (parseInt(position) === parseInt(index)) ? isChecked : false;
            updatedSubscription['approved_by'] = (position === index) ? (isChecked ? customer.username : '') : '';

            return updatedSubscription;
        });
        setOpportunityData({
            ...opportunityData,
            ie_bid_team: {
                ...opportunityData.ie_bid_team,
                external_bid_team: updatedEntities
            }
        });
    };

    /**
     * Function to check and render the display name or option names based on availability in the row data.
     * @param {Object} rowData - The data of the row being rendered.
     * @returns {JSX.Element} - The JSX element containing the display name or option names.
     */

    const teamMember = (rowData) => {
        if (rowData.team_member != null && rowData.team_member !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.team_member}</div></div>
            );
        }
    };

    const role = (rowData) => {
        if (rowData.role != null && rowData.role !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.role}</div></div>
            );
        }
    };

    const handleChange = (val, index) => {
        const updatedArrayData = { ...opportunityData };
        updatedArrayData.ie_bid_team.internal_bid_team[index].bid_team_role = val.label;

        // Logic from bidTeamRoleChange
        for (let i = 0; i < teamLeader.length; i++) {
            if (val.label === teamLeader[i]) {
                const firstIndex = _.findIndex(updatedArrayData.ie_bid_team.internal_bid_team, {
                    bid_team_role: teamLeader[i]
                });
                const lastIndex = _.findLastIndex(updatedArrayData.ie_bid_team.internal_bid_team, {
                    bid_team_role: teamLeader[i]
                });

                if (firstIndex !== -1 && firstIndex !== lastIndex) {
                    updatedArrayData.ie_bid_team.internal_bid_team[index].bid_team_role = "";

                    toastRef.current.showToast({
                        type: "error",
                        message: "Only one Project Leader is allowed",
                    });
                }
            }
        }
        setOpportunityData(updatedArrayData);
    };

    const teamRole = (row, index) => {
        if (row.bid_team_role != 'Bid Leader') {
            const team_role = row.bid_team_role;

            const matched = props?.bdLongShotRole.find(
                (item) => item.label === team_role
            );
            return (
                <DropdownElement
                    onChange={(e) => handleChange(e.value, index.rowIndex)}
                    id="team_role"
                    options={(props?.bdLongShotRole != undefined && props?.bdLongShotRole.length > 0) ? props?.bdLongShotRole : []}
                    optionLabel="label"
                    placeholder="-- Please select --"
                    className={(props.errors.includes('Bid Team Role') && row.bid_team_role == undefined) ? 'error-tab w-150' : 'w-150'}
                    maxSelectedLabels={1}
                    value={matched ? matched : null}
                    disabled={!teamEditPrivilege}
                />
            );
        } else {
            return row.bid_team_role
        }
    };

    const estHours = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.total_est_hours}
                    field="estHours"
                    placeholder="0"
                    keyfilter="int"
                    onChange={onTextChangeEstHours(index?.rowIndex, "total_est_hours")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const actHours = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.total_actual}
                    placeholder="0"
                    keyfilter="int"
                    onChange={onTextChangeEstHours(index?.rowIndex, "total_actual")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const lastUpdatedDate = (row, index) => {
        return (
            <div className="flex align-items-center">
                <CalendarElement
                    id="actual_to_date"
                    className='ml-10'
                    defaultValue={parseDateString(row.actual_to_date)}
                    value={parseDateString(row.actual_to_date)}
                    onChange={(value) => {
                        handleCalenderInputChange("actual_to_date", value.value, index.rowIndex);
                    }}
                    maxLength="50"
                    placeholder="Date"
                    autocomplete="off"
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const phoneNumber = (rowData) => {
        if (rowData.phone_number != null && rowData.phone_number !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.phone_number}</div></div>
            );
        }
    };

    const mobileNumber = (rowData) => {
        if (rowData.mobile_number != null && rowData.mobile_number !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.mobile_number}</div></div>
            );
        }
    };

    const email = (rowData) => {
        if (rowData.email != null && rowData.email !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.email}</div></div>
            );
        }
    };

    const actual_complete = (row, index) => {
        if (row.actual_complete != null && row.actual_complete !== '') {
            return (
                <CheckboxElement
                    id="actual_complete"
                    name="actual_complete"
                    checked={row.actual_complete}
                    onChangeCheck={(e) => handleCompleted(e, index?.rowIndex, "actual_complete")}
                    className="mr-2"
                    disabled={!teamEditPrivilege}
                />
            );
        }
    };

    const externalOrganisation = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className={(props.errors.includes('External Organisation') && row.external_organisation == '') ? 'error-tab w-full' : 'w-full'}
                    value={row.external_organisation}
                    placeholder=""
                    onChange={onTextChangeExternal(index?.rowIndex, "external_organisation")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const serviceDescription = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className={(props.errors.includes('External Organisation') && row.service_description == '') ? 'error-tab w-full' : 'w-full'}
                    value={row.service_description}
                    placeholder=""
                    onChange={onTextChangeExternal(index?.rowIndex, "service_description")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const estimatedCost = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    name="estimated_cost"
                    className={(props.errors.includes('External Organisation') && row.estimated_cost == '') ? 'error-tab w-full' : 'w-full'}
                    value={row.estimated_cost}
                    keyfilter="int"
                    placeholder=""
                    onChange={onTextChangeExternal(index?.rowIndex, "estimated_cost")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const actualCost = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.actual_cost}
                    placeholder=""
                    keyfilter="int"
                    onChange={onTextChangeExternal(index?.rowIndex, "actual_cost")}
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const lastUpdatedDateExternal = (row, index) => {
        return (
            <div className="flex align-items-center">
                <CalendarElement
                    id="actual_to_date"
                    className='ml-10'
                    defaultValue={parseDateString(row.actual_to_date)}
                    value={parseDateString(row.actual_to_date)}
                    onChange={(value) => {
                        handleCalenderInputChangeExt("actual_to_date", value.value, index.rowIndex);
                    }}
                    maxLength="50"
                    placeholder="Date"
                    autocomplete="off"
                    disabled={!teamEditPrivilege}
                />
            </div>
        );
    };

    const approvedExternal = (row, index) => {
        if (row.approved != null && row.approved !== '') {
            return (
                <CheckboxElement
                    id="approved"
                    name="approved"
                    checked={row.approved}
                    onChangeCheck={(e) => handleCompletedExternal(e, index?.rowIndex, "approved")}
                    className="mr-2"
                    disabled={!teamEditPrivilege}
                />);
        }
    };

    const approvedByExternal = (rowData) => {
        if (rowData.approved_by != null && rowData.approved_by !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.approved_by}</div></div>
            );
        }
    };

    const columns = [
        {
            field: "team_member",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Team Member' })?.display_name,
            body: teamMember,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "role",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Role' })?.display_name,
            body: role,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "team_role",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Bid Team Role' })?.display_name,
            body: teamRole,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "hourly_rate",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Est Hours' })?.display_name,
            body: estHours,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "actual_hours_to_date",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Actual Hours to Date' })?.display_name,
            body: actHours,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "actual_to_date",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Last Updated Date' })?.display_name,
            body: lastUpdatedDate,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "phone_number",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Phone Number' })?.display_name,
            body: phoneNumber,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "mobile_number",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Mobile Number' })?.display_name,
            body: mobileNumber,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "email",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Email' })?.display_name,
            body: email,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "actual_complete",
            header: _.find(props.TeamData.internalTeamHeaders, { header_name: 'Actual Complete' })?.display_name,
            body: actual_complete,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
    ]

    function generateRandomID() {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }

    const columnsExternalTable = [
        {
            field: "external_organisation",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'External Organisation' })?.display_name,
            body: externalOrganisation,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "service_description",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Service Description' })?.display_name,
            body: serviceDescription,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "estimated_cost",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Estimated Cost' })?.display_name,
            body: estimatedCost,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "actual_cost",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Actual Cost' })?.display_name,
            body: actualCost,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "actual_to_date",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Last Updated Date' })?.display_name,
            body: lastUpdatedDateExternal,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "approved_external",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Approved' })?.display_name,
            body: approvedExternal,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "approved_by_external",
            header: _.find(props.TeamData.externalTeamHeaders, { header_name: 'Approved By' })?.display_name,
            body: approvedByExternal,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        }

    ]

    const rowClick = async (data) => {
        setSelectedOption(data)
    };

    const addItemInternal = () => {
        if (teamEditPrivilege) {
            setModelOpen(true);
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };

    const closePopup = () => {
        setModelOpen(false);
        setRoles('')
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Add" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }

    const addItemExternal = () => {
        if (teamEditPrivilege) {
            const newRow = {
                approved: false,
                _id: generateRandomID(),
                external_organisation: "",
                service_description: "",
                estimated_cost: '',
                actual_cost: '',
                actual_to_date: ""
            }

            // Create a copy of the existing data
            const updatedData = { ...opportunityData };

            // Retrieve the existing external_bid_team
            const externalBidTeam = updatedData.ie_bid_team.external_bid_team;

            // Find the next available numerical key for the new item
            const nextKey = Object.keys(externalBidTeam).reduce((max, key) => {
                const numKey = parseInt(key, 10);
                return numKey > max ? numKey : max;
            }, -1) + 1;

            // Add the new item with the next available key
            updatedData.ie_bid_team.external_bid_team[nextKey] = newRow;

            // Remove the bid_team_roles array if it exists (since we are using numerical keys directly)
            if (updatedData.ie_bid_team.external_bid_team.bid_team_roles) {
                delete updatedData.ie_bid_team.external_bid_team.bid_team_roles;
            }

            // Update the state with the new data
            setOpportunityData(updatedData);
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };

    const handleDeleteExternal = () => {
        if (teamEditPrivilege) {
            const updatedOptions = opportunityData.ie_bid_team?.external_bid_team.filter(
                (row) => !selectedOption.includes(row)
            );
            opportunityData.ie_bid_team.external_bid_team = updatedOptions;
            setOpportunityData((prevState) => ({
                ...prevState,
                ie_bid_team: {
                    ...prevState.ie_bid_team,
                    external_bid_team: updatedOptions
                }
            }));
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };

    const handleDeleteInternal = () => {
        if (teamEditPrivilege) {
            const updatedOptions = opportunityData.ie_bid_team?.internal_bid_team.filter(
                (row) => !selectedOption.includes(row)
            );
            opportunityData.ie_bid_team.internal_bid_team = updatedOptions;
            setOpportunityData((prevState) => ({
                ...prevState,
                ie_bid_team: {
                    ...prevState.ie_bid_team,
                    internal_bid_team: updatedOptions
                }
            }));
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
            {
                (!_.isEmpty(opportunityData)) &&
                <form>
                    {
                        Object.entries(newModule)?.map(([key, value]) => (
                            <div key={key} className='mt-10'>
                                <Accordion activeIndex={0}>
                                    {
                                        <AccordionTab header={value} disabled>
                                            {
                                                key == 'obj1' &&
                                                <div className='new-field'>
                                                    {
                                                        _.find(props.TeamData.tableFieldsBidTeam, { table_name: "Internal Team List" })?.status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col p-0">
                                                                <div className="form-group row align-items-center mb-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <p className="label-text">
                                                                            {_.find(props.TeamData.tableFieldsBidTeam, { table_name: "Internal Team List" })?.display_name}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col pr-0 d-flex justify-end">
                                                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteInternal} />
                                                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemInternal} />
                                                                    </div>
                                                                </div>
                                                                <DataTable
                                                                    value={opportunityData.ie_bid_team?.internal_bid_team}
                                                                    columns={columns}
                                                                    dataKey="_id"
                                                                    isNotReorder={true}
                                                                    rowClick={rowClick}
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                key == 'obj2' &&
                                                <div className='new-field'>
                                                    {
                                                        _.find(props.TeamData.tableFieldsBidTeam, { table_name: "External Team List" })?.status &&
                                                        <div className="form-group row mb-0 mt-0">
                                                            <div className="col p-0">
                                                                <div className="form-group row align-items-center mb-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <p className="label-text">
                                                                            {_.find(props.TeamData.tableFieldsBidTeam, { table_name: "External Team List" })?.display_name}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col pr-0 d-flex justify-end">
                                                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteExternal} />
                                                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemExternal} />
                                                                    </div>
                                                                </div>
                                                                <DataTable
                                                                    value={opportunityData.ie_bid_team?.external_bid_team}
                                                                    columns={columnsExternalTable}
                                                                    dataKey="_id"
                                                                    isNotReorder={true}
                                                                    rowClick={rowClick}
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </AccordionTab>
                                    }
                                </Accordion>
                            </div>
                        ))
                    }
                </form>
            }
            <Dialog
                visible={isModelOpen}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Team Members"
                modal
                position="right"
                onHide={closePopup}
                footer={renderFooter()}
                className="width-32"
                draggable={false}
            >
                <div className='new-field'>
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className='col-md-4 pl-0'>
                            <label className="form-label text-left">
                                Users:
                            </label>
                        </div>
                        <div className="col pl-0">
                            <Controller
                                name="owner"
                                control={control}
                                render={({ field }) => {
                                    return (
                                        <SingleSelectElement
                                            id="owner"
                                            {...field}
                                            name="firstname"
                                            options={(props.relationshipOwner != undefined && props.relationshipOwner.length > 0) ? props.relationshipOwner : []}
                                            optionLabel="label"
                                            placeholder="-- Please select --"
                                            maxSelectedLabels={1}
                                            onChangeValue={(e) => handleUserChange(e)}
                                            className="w-full"
                                        />
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className='col-md-4 pl-0'>
                            <label className="form-label text-left">
                                Role:
                            </label>
                        </div>
                        <div className="col pl-0">
                            <span className="form-label text-left">{roles || "No role selected"}</span>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_team" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}